import React, { useEffect, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import moment from 'moment';
import { FormattedMessage as FM } from 'react-intl';
import { currentDate } from 'common/dashboards/helpers';
import MonthPicker from 'common/components/MonthPicker';
import { analyticsAccess } from 'crm/analytics/permissions';
import { getCRMAnalytics } from '../../_redux';
import { ClientsTable, RightChart, UsersChart } from './_components';

import { staticStyles } from './style';

const ClientsPage = ({ analyticsData, getCRMAnalytics, profilePerms }) => {
  const access = analyticsAccess(profilePerms);
  const location = useLocation();
  const history = useHistory();

  const [date, setDate] = useState(currentDate);

  const startOfMonth = moment(date).startOf('month').format('YYYY-MM-DD');
  const endOfMonth = moment(date).endOf('month').format('YYYY-MM-DD');
  const splittedDate = `${startOfMonth}_${endOfMonth}`;

  const currentYear = Number(moment().format('YYYY'));
  const currentMonthNum = Number(moment().format('M'));
  const [dayDates, allDayData] = useMemo(() => {
    let dayDates = [];
    let allDayData = [];

    Object.entries(analyticsData).forEach(([date, dayData]) => {
      dayDates = [...dayDates, date.replace(/^\d+-/, '')];
      allDayData = [...allDayData, dayData];
    });

    return [dayDates, allDayData];
  }, [analyticsData]);

  const [monthValue, setMonthValue] = useState({
    year: currentYear,
    month: currentMonthNum,
  });
  const handleMonthChange = monthValue => {
    setMonthValue(monthValue);
    setDate(moment(`${monthValue.year}-${monthValue.month}`).format('YYYY-MM'));

    history.replace({
      ...location,
      search: queryString.stringify({ page: 1, page_size: 10 }),
    });
  };

  useEffect(() => {
    getCRMAnalytics({ date: splittedDate });
  }, [date]);

  return (
    <div className="ClientsPageAnalytics">
      <FM id="crmAnalytics">{txt => <h1 className="ClientsPageAnalytics__title">{txt}</h1>}</FM>
      <div className="ClientsPageAnalytics__Charts">
        <MonthPicker
          crmStyle
          monthValue={monthValue}
          years={{ min: { year: 2010, month: 1 }, max: { year: currentYear, month: currentMonthNum } }}
          handleChange={handleMonthChange}
        />
        <UsersChart dayDates={dayDates} allDayData={allDayData} />
        {(access.totalIn || access.totalOut) && (
          <RightChart dayDates={dayDates} allDayData={allDayData} access={access} />
        )}
      </div>
      <FM id="crmClients">{txt => <h1 className="ClientsPageAnalytics__title">{txt}</h1>}</FM>
      <ClientsTable date={splittedDate} />
      <style jsx global>
        {staticStyles}
      </style>
    </div>
  );
};

ClientsPage.propTypes = {
  analyticsData: PropTypes.object.isRequired,
  getCRMAnalytics: PropTypes.func.isRequired,
  profilePerms: PropTypes.object.isRequired,
};

export default connect(
  state => ({
    profilePerms: state.user.profile.perms,
    analyticsData: state.crm.analytics.analyticsData,
    analyticsDataIsLoaded: state.crm.analytics.analyticsDataIsLoaded,
  }),
  {
    getCRMAnalytics: data => getCRMAnalytics.request(data),
  }
)(ClientsPage);
